<template>
  <div class="my-10">
    <div class="flex justify-between mb-5">
      <h1 class="text-2xl font-bold">
        {{ $t('nav.stores') }}
      </h1>
      <button
        @click="toggleFilter(true)"
        class="hidden gap-2 items-center text-main-color bg-white p-2 rounded-lg max-lg:flex"
      >
        <IconFilter />
        <p>{{ $t('page.filter') }}</p>
      </button>
    </div>
    <div class="grid grid-cols-4 gap-5">
      <div class="col-span-1">
        <MallStoreSide
          @closeFilter="toggleFilter(false)"
          :filterState="filterState"
          :currentCategory="query.categories"
          :currentSubscription="query.subscription"
          :isVip="query.is_vip"
          :currentIsNew="query.is_new"
          :currentIsPromotion="query.in_promotion"
          :currentHasDiscount="query.has_discount"
          :currentForCredit="query.for_credit"
          :location="getLocation.id"
          :cat="infoQuery.cat"
          :subcat="infoQuery.subcat"
          :subsubcat="infoQuery.subsubcat"
          :hideFilters="['currentPrice', 'currentBrands']"
        ></MallStoreSide>
      </div>
      <div class="col-span-3 max-lg:col-span-4">
        <div class="grid grid-cols-3 gap-4 max-lg:grid-cols-2">
          <template v-if="stores.length > 0">
            <router-link
              v-for="item in stores"
              :key="item?.id"
              :to="{ name: 'storeDetail', params: { id: item?.id } }"
            >
              <StoreCard :detail="item"> </StoreCard>
            </router-link>
          </template>
        </div>
        <div v-show="stores.length === 0 && loading === false">
          <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
        </div>
        <div v-show="loading === true" class="flex justify-center mt-10" role="status">
          <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin fill-main-color">
          </IconSpinner>

          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSpinner from '@icons/IconSpinner.vue';
import IconFilter from '@icons/IconFilter.vue';
import StoreCard from '@cmp/mall/StoreCard.vue';
import MallStoreSide from '@cmp/mall/MallStoreSide.vue';
import api from '@/api';
import { updateLastSeen } from '@/helpers';
export default {
  name: 'stores',
  components: {
    StoreCard,
    MallStoreSide,
    IconSpinner,
    IconFilter,
  },
  watch: {
    '$route.query': {
      deep: true,
      async handler(newQuery) {
        this.query.categories = newQuery.category;
        this.query.subscription = newQuery.subscription;
        this.query.is_vip = newQuery.is_vip;
        this.query.is_new = newQuery.is_new;
        this.query.in_promotion = newQuery.in_promotion;
        this.query.has_discount = newQuery.has_discount;
        this.query.for_credit = newQuery.for_credit;
        this.query.location = this.getLocation.id;
        this.query.page = 1;

        this.infoQuery.cat = newQuery.cat;
        this.infoQuery.subcat = newQuery.subcat;
        this.infoQuery.subsubcat = newQuery.subsubcat;

        this.stores = [];
        this.next = null;

        await this.getStores();
      },
    },
  },
  data() {
    return {
      loading: false,
      stores: [],
      storesRequestKey: 0,
      count: 0,
      next: null,
      query: {
        categories: undefined,
        subscription: undefined,
        is_vip: undefined,
        is_new: undefined,
        in_promotion: undefined,
        has_discount: undefined,
        for_credit: undefined,
        location: undefined,
        page: 1,
      },
      infoQuery: {
        cat: null,
        subcat: null,
        subsubcat: null,
      },
      filterState: false,
    };
  },
  methods: {
    toggleFilter(e) {
      this.filterState = e;
      document.body.style.overflowY = e ? 'hidden' : 'initial';
    },
    infiniteScroll() {
      let scrollTop = document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      let clientHeight = document.documentElement.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 650) {
        if (this.next !== null && this.loading === false) {
          this.query.page += 1;
          this.getStores();
        }
      }
    },
    async getStores() {
      const requestKey = ++this.storesRequestKey;
      const currentPage = Number(this.query.page || 1);

      this.loading = true;

      try {
        const response = await api.get('mall/stores/', {
          params: this.query,
        });

        if (requestKey !== this.storesRequestKey) {
          return;
        }

        const results = response.data.results || [];

        if (currentPage === 1) {
          this.stores = results;
        } else {
          this.stores.push(...results);
        }

        this.count = response.data.count;
        this.next = response.data.next;
      } catch (e) {
        if (requestKey === this.storesRequestKey) {
          console.log(e);
        }
      } finally {
        if (requestKey === this.storesRequestKey) {
          this.loading = false;
        }
      }
    },
  },
  computed: {
    getLocation() {
      return JSON.parse(localStorage.getItem('selectedLocation')) || 1;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.infiniteScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.infiniteScroll);
  },
  async created() {
    this.query.categories = this.$route.query.category;
    this.query.subscription = this.$route.query.subscription;
    this.query.is_vip = this.$route.query.is_vip;
    ((this.query.is_new = this.$route.query.is_new),
      (this.query.in_promotion = this.$route.query.in_promotion),
      (this.query.has_discount = this.$route.query.has_discount),
      (this.query.for_credit = this.$route.query.for_credit),
      (this.query.location = this.getLocation.id),
      (this.infoQuery.cat = this.$route.query.cat));
    this.infoQuery.subcat = this.$route.query.subcat;
    this.infoQuery.subsubcat = this.$route.query.subsubcat;
    await this.getStores();
    updateLastSeen('mall_stores');
  },
};
</script>

<style scoped></style>
